import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["isOpen", "onClose", "dataTestId", "variantProps", "isLoading", "landscapeModal"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Heading, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, ModalFooter, Text, Button, Image } from '@chakra-ui/react';
import { Dismiss } from '../../../../assets/icons';
import LoadingSpinner from '../../../LoadingSpinner';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ModalHeaderContent = _ref => {
  var title = _ref.title,
    priceText = _ref.priceText,
    prefix = _ref.prefix,
    isPrimary = _ref.isPrimary;
  return _jsxs(Flex, _objectSpread(_objectSpread({}, isPrimary ? _objectSpread(_objectSpread({}, styles.header), {}, {
    p: 0
  }) : _objectSpread({}, styles.header)), {}, {
    children: [_jsxs(Box, {
      children: [_jsx(Heading, _objectSpread(_objectSpread({}, styles.title), {}, {
        children: title
      })), priceText && _jsx(Text, _objectSpread(_objectSpread({}, styles.priceText), {}, {
        children: priceText
      }))]
    }), _jsx(ModalCloseButton, _objectSpread(_objectSpread({
      "data-testid": "".concat(prefix, "ModalCloseButton")
    }, styles.modalCloseButton), {}, {
      children: _jsx(Icon, _objectSpread({
        as: Dismiss
      }, styles.closeIcon))
    }))]
  }));
};
var RoomUpgradeModal = _ref2 => {
  var isOpen = _ref2.isOpen,
    onClose = _ref2.onClose,
    _ref2$dataTestId = _ref2.dataTestId,
    dataTestId = _ref2$dataTestId === void 0 ? '' : _ref2$dataTestId,
    variantProps = _ref2.variantProps,
    isLoading = _ref2.isLoading,
    landscapeModal = _ref2.landscapeModal,
    modalProps = _objectWithoutProperties(_ref2, _excluded);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  var _ref3 = landscapeModal !== null && landscapeModal !== void 0 ? landscapeModal : {},
    primary = _ref3.primary,
    secondary = _ref3.secondary;
  var spinner = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
  return _jsxs(Modal, _objectSpread(_objectSpread({
    "data-testid": "".concat(prefix, "ChakraModal"),
    scrollBehavior: "inside",
    isOpen: isOpen,
    onClose: onClose,
    closeOnOverlayClick: false,
    isCentered: true,
    motionPreset: "slideInBottom",
    size: primary ? 'xxl' : 'lg'
  }, modalProps), {}, {
    children: [_jsx(ModalOverlay, {}), !primary && !secondary && _jsx(_Fragment, {
      children: _jsxs(ModalContent, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalContent"),
        minH: "250px"
      }, modalStyles), {}, {
        children: [_jsx(ModalHeader, {
          p: "0",
          "data-testid": "".concat(prefix, "ModalHeader"),
          children: (variantProps === null || variantProps === void 0 ? void 0 : variantProps.title) && (variantProps === null || variantProps === void 0 ? void 0 : variantProps.priceText) && _jsx(ModalHeaderContent, {
            title: variantProps.title,
            priceText: variantProps.priceText,
            prefix: prefix,
            isPrimary: primary
          })
        }), _jsx(ModalBody, _objectSpread(_objectSpread({
          p: "0",
          "data-testid": "".concat(prefix, "ModalBody")
        }, contentStyles), {}, {
          children: _jsxs(Flex, {
            direction: "column",
            px: 4,
            py: 1,
            children: [(variantProps === null || variantProps === void 0 ? void 0 : variantProps.imageSrc) && _jsx(Image, _objectSpread(_objectSpread({}, imageStyles), {}, {
              src: variantProps.imageSrc,
              alt: variantProps.title,
              mb: 2,
              borderRadius: "8px",
              objectFit: "cover"
            })), (variantProps === null || variantProps === void 0 ? void 0 : variantProps.description) && _jsx(Box, {
              children: variantProps.description
            }), isLoading && _jsx(Box, _objectSpread(_objectSpread({}, spinner), {}, {
              children: _jsx(LoadingSpinner, {})
            }))]
          })
        })), _jsx(ModalFooter, {
          p: "4",
          children: variantProps && _jsxs(Flex, {
            direction: "column",
            gap: 2,
            w: "full",
            justify: "center",
            children: [variantProps.primaryButtonLabel && _jsx(Button, _objectSpread(_objectSpread({}, styles.button), {}, {
              onClick: variantProps.onPrimaryAction,
              variant: "primary",
              flex: 1,
              size: "full",
              "data-testid": "".concat(prefix, "PrimaryButton"),
              children: variantProps.primaryButtonLabel
            })), variantProps.secondaryButtonLabel && _jsx(Button, _objectSpread(_objectSpread({}, styles.button), {}, {
              onClick: variantProps.onSecondaryAction,
              variant: "tertiary",
              flex: 1,
              size: "full",
              "data-testid": "".concat(prefix, "SecondaryButton"),
              children: variantProps.secondaryButtonLabel
            }))]
          })
        })]
      }))
    }), (primary || secondary) && _jsx(_Fragment, {
      children: _jsxs(ModalContent, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalContent"),
        minH: secondary ? 'none' : '250px',
        maxH: "317px",
        ml: {
          mobile: '1rem',
          sm: '0'
        },
        mr: {
          mobile: '1rem',
          sm: '0'
        }
      }, primary ? _objectSpread({}, modalStylesLandscapeDefault) : _objectSpread({}, modalStylesLandscapeVariant)), {}, {
        flexDirection: "row",
        children: [!secondary && _jsx(Box, {
          w: "50%",
          p: "4",
          children: (variantProps === null || variantProps === void 0 ? void 0 : variantProps.imageSrc) && _jsx(Image, _objectSpread(_objectSpread({}, imageStylesLandscape), {}, {
            src: variantProps.imageSrc,
            alt: variantProps.title,
            mb: 2,
            borderRadius: "8px",
            objectFit: "cover",
            h: "100%"
          }))
        }), _jsx(Box, {
          w: secondary ? '100%' : '50%',
          p: "4",
          children: _jsxs(Flex, {
            direction: "column",
            height: "100%",
            justifyContent: "space-between",
            children: [_jsx(ModalHeader, {
              p: "0",
              "data-testid": "".concat(prefix, "ModalHeader"),
              children: (variantProps === null || variantProps === void 0 ? void 0 : variantProps.title) && (variantProps === null || variantProps === void 0 ? void 0 : variantProps.priceText) && _jsx(ModalHeaderContent, {
                title: variantProps.title,
                priceText: variantProps.priceText,
                prefix: prefix,
                isPrimary: primary
              })
            }), _jsxs(ModalBody, _objectSpread(_objectSpread({
              p: "0",
              "data-testid": "".concat(prefix, "ModalBody")
            }, contentStyles), {}, {
              children: [(variantProps === null || variantProps === void 0 ? void 0 : variantProps.description) && _jsx(Box, {
                maxH: secondary ? '40px' : '77px',
                children: variantProps.description
              }), isLoading && _jsx(Box, _objectSpread(_objectSpread({}, spinner), {}, {
                children: _jsx(LoadingSpinner, {})
              }))]
            })), _jsx(ModalFooter, {
              p: "0",
              mt: "2",
              children: variantProps && _jsxs(Flex, {
                direction: secondary ? 'row' : 'column',
                gap: 2,
                w: "full",
                justify: "center",
                children: [variantProps.primaryButtonLabel && _jsx(Button, _objectSpread(_objectSpread({}, secondary ? _objectSpread(_objectSpread({}, styles.buttonLandscape), {}, {
                  fontSize: 'md',
                  padding: 2,
                  height: '40px'
                }) : _objectSpread({}, styles.buttonLandscape)), {}, {
                  onClick: variantProps.onPrimaryAction,
                  variant: "primary",
                  flex: 1,
                  size: "full",
                  "data-testid": "".concat(prefix, "PrimaryButton"),
                  children: variantProps.primaryButtonLabel
                })), variantProps.secondaryButtonLabel && _jsx(Button, _objectSpread(_objectSpread({}, secondary ? _objectSpread(_objectSpread({}, styles.buttonLandscape), {}, {
                  fontSize: 'md',
                  padding: 2,
                  height: '40px'
                }) : _objectSpread({}, styles.buttonLandscape)), {}, {
                  onClick: variantProps.onSecondaryAction,
                  variant: "tertiary",
                  flex: 1,
                  size: "full",
                  "data-testid": "".concat(prefix, "SecondaryButton"),
                  children: variantProps.secondaryButtonLabel
                }))]
              })
            })]
          })
        })]
      }))
    })]
  }));
};
var styles = {
  modalCloseButton: {
    h: 'var(--chakra-space-xl)',
    w: 'var(--chakra-space-xl)',
    ml: 'auto',
    position: 'static',
    _focus: {
      boxShadow: 'none'
    },
    _hover: {
      bgColor: 'transparent'
    },
    _active: {
      bgColor: 'transparent'
    }
  },
  header: {
    p: 4,
    pb: 2,
    justify: 'space-between',
    align: 'baseline'
  },
  title: {
    as: 'h2',
    size: 'md',
    color: '#511E62',
    fontWeight: '900'
  },
  priceText: {
    fontSize: 'sm',
    color: '#333333',
    fontWeight: '600',
    mt: '5px'
  },
  closeIcon: {
    transform: 'scale(1.1)',
    stroke: '#511E62'
  },
  button: {
    fontSize: {
      mobile: 'md',
      lg: 'lg'
    },
    padding: {
      mobile: 2,
      lg: 4
    },
    height: {
      mobile: '40px',
      lg: '56px'
    }
  },
  buttonLandscape: {
    fontSize: 'lg',
    padding: 4,
    height: '56px'
  },
  buttonLandscapeCommon: {
    fontSize: 'lg',
    padding: 4,
    height: '56px'
  }
};
var contentStyles = {
  sx: {
    ul: {
      ml: 'md'
    }
  },
  fontSize: 'sm',
  lineHeight: '20px'
};
var modalStyles = {
  w: {
    mobile: '287px',
    lg: '410px'
  },
  ml: {
    mobile: '1rem',
    sm: '0'
  },
  mr: {
    mobile: '1rem',
    sm: '0'
  },
  marginTop: '1.5rem',
  maxHeight: {
    mobile: '470px',
    lg: '503px'
  }
};
var modalStylesLandscapeDefault = {
  w: '812px',
  marginTop: 'auto',
  maxHeight: {
    mobile: '470px',
    lg: '317px'
  }
};
var modalStylesLandscapeVariant = {
  w: {
    mobile: '287px',
    lg: '737px'
  },
  marginTop: '1.5rem',
  maxHeight: {
    mobile: '470px',
    lg: '503px'
  }
};
var imageStyles = {
  maxHeight: {
    mobile: '100%',
    md: '140px',
    lg: '190px'
  }
};
var imageStylesLandscape = {
  maxHeight: {
    mobile: '100%',
    md: 'full'
  }
};
export default RoomUpgradeModal;